import gql from "graphql-tag";
import graphqlClient from "@/http/graphql/rice";

export const fragments = {
	Inventory: `
		fragment Inventory on Inventory {
			id
			name
			street
			description
		}
	`,
};

export const GET_INVENTORIES = `
	inventories {
		...Inventory
	}
`;

export default {
	init() {},

	fetchInventories(payload) {
		const queryOptions = {
			query: gql`query Inventories {
				${GET_INVENTORIES}
			}
			${fragments.Inventory}
			`
		};
		if (payload.fetchPolicy) {
			queryOptions.fetchPolicy = payload.fetchPolicy;
		}
		return graphqlClient.query(queryOptions).then(response => {
			return {
				inventories: response.data.inventories,
			};
		});
	}
};
